import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { Gear } from '@ankr.com/ui';
import { IconButton, Typography } from '@mui/material';

import { useAccount } from 'modules/account/hooks/useAccount';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';
import { UserSettingsRoutesConfig } from 'domains/userSettings/Routes';

import { notificationsMenuTranslation } from '../../translation';
import { useHeaderStyles } from './useHeaderStyles';

interface IHeaderProps {
  onClose: () => void;
}

export const Header = ({
  onClose,
}: IHeaderProps) => {
  const { classes } = useHeaderStyles();
  const { keys, t } = useTranslation(notificationsMenuTranslation);

  const navigate = useNavigate();

  const { group } = useAccount();

  const redirectToSettings = useCallback(() => {
    const redirectUrl = group
      ? UserSettingsRoutesConfig.teamNotifications.generatePath()
      : UserSettingsRoutesConfig.notifications.generatePath();

    navigate(redirectUrl);

    onClose();
  }, [group, navigate, onClose]);

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2">{t(keys.title)}</Typography>
      <IconButton
        className={classes.button}
        onClick={redirectToSettings}
      >
        <Gear className={classes.icon} />
      </IconButton>
    </div>
  );
};
